const URL = "https://wa.me";

const whatsAppApi = () => {
    let url = `${URL}/+244945340710`;

    return window.open(url);
}

export default whatsAppApi;